var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 1.99992H13.1134C13.4907 1.99325 13.8573 2.12534 14.1436 2.37113C14.43 2.61692 14.6161 2.95929 14.6667 3.33325V7.99992C14.6161 8.37388 14.43 8.71625 14.1436 8.96204C13.8573 9.20783 13.4907 9.33993 13.1134 9.33325H11.3334M6.66669 10.6666V13.3333C6.66669 13.8637 6.8774 14.3724 7.25247 14.7475C7.62755 15.1225 8.13625 15.3333 8.66669 15.3333L11.3334 9.33325V1.99992H3.81335C3.4918 1.99629 3.17977 2.10898 2.93475 2.31725C2.68973 2.52552 2.52824 2.81532 2.48002 3.13325L1.56002 9.13325C1.53102 9.32435 1.5439 9.51947 1.59779 9.70509C1.65168 9.89071 1.74529 10.0624 1.87211 10.2082C1.99894 10.3541 2.15597 10.4706 2.33231 10.5498C2.50864 10.6289 2.70008 10.6688 2.89335 10.6666H6.66669Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.06174b7c5e8ddd556d44db424e66afd6.svg";
export { ForwardRef as ReactComponent };